import _toConsumableArray from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { threadList, follow, unFollow, followList, userRegister, thumbs, collect } from '@/api/mg';
var threadListParams = {
  perPage: 1000,
  page: 1,
  'filter[essence]': 0,
  'filter[attention]': 0,
  'filter[sort]': 3,
  sequence: 0
};
export default {
  data: function data() {
    var _ref;
    return _ref = {
      userId: '',
      title: '',
      name: '',
      nickname: '',
      leftIcon: require('../../assets/images/ic_mg_club_search.png'),
      clubData: [],
      followList: []
    }, _defineProperty(_ref, "nickname", ''), _defineProperty(_ref, "show", false), _defineProperty(_ref, "isBack", true), _defineProperty(_ref, "meId", null), _ref;
  },
  created: function created() {
    var _this = this;
    var params = JSON.parse(localStorage.getItem('appParams'));
    var registerParams = {
      mobilePhone: params.mobilePhone,
      nickname: params.nickname,
      uuid: params.uid,
      avatar: params.avatar || localStorage.getItem('avatar')
    };
    if (!localStorage.getItem('isBack')) {
      localStorage.setItem('isBack', this.$route.query.isBack);
      this.isBack = localStorage.getItem('isBack');
    }
    userRegister(registerParams).then(function (res) {
      if (res.Code === 0) {
        _this.meId = localStorage.getItem('userId');
        console.log(_this.meId, 1111111);
        localStorage.setItem('socialToken', res.Data.accessToken);
        _this.$store.state.socialToken = res.Data.accessToken;
        // this.userId = localStorage.getItem('userId')
        _this.name = _this.$route.query.str;
        _this.toUserId = _this.$route.query.toUserId;
        // if (this.userId === this.toUserId) {
        _this.title = 'My ' + _this.name;
        // } else {
        //   this.title = this.name
        // }
        threadListParams.page = 1;
        threadListParams['filter[sort]'] = 1;
        if (_this.name === 'Works') {
          threadListParams['filter[toUserId]'] = _this.toUserId;
          threadListParams['filter[complex]'] = 5;
          _this.getThreadList(threadListParams);
        }
        if (_this.name === 'Favorites') {
          threadListParams['filter[toUserId]'] = _this.toUserId;
          threadListParams['filter[complex]'] = 3;
          _this.getThreadList(threadListParams);
        }
        var _params = {
          page: 1,
          perPage: 1000
        };
        if (_this.name === 'Follow') {
          _params['filter[userId]'] = _this.toUserId;
          _params['filter[type]'] = 1;
          _params['filter[nickName]'] = _this.nickname;
          _this.getFollowList(_params);
        }
        if (_this.name === 'Fans') {
          _params['filter[userId]'] = _this.toUserId;
          _params['filter[type]'] = 2;
          _params['filter[nickName]'] = _this.nickname;
          _this.getFollowList(_params);
        }
      } else {
        _this.$toast(res.Message);
      }
    });
    // this.getParams()
  },

  methods: {
    toMe: function toMe(pid) {
      console.log(pid);
      this.$router.push({
        path: '/others',
        query: {
          pid: pid
        }
      });
    },
    input: function input(nickname) {
      var params = {
        page: 1,
        perPage: 1000
      };
      if (nickname.trim() !== '') {
        // if (/^[A-Za-z0-9\u4e00-\u9fa5]+$/.test(nickname)) {
        if (this.name === 'Follow') {
          params['filter[userId]'] = this.toUserId;
          params['filter[type]'] = 1;
          params['filter[nickName]'] = this.nickname;
          this.getFollowList(params);
        }
        if (this.name === 'Fans') {
          params['filter[userId]'] = this.toUserId;
          params['filter[type]'] = 2;
          params['filter[nickName]'] = this.nickname;
          this.getFollowList(params);
        }
        console.log(params, 'params');
        // }
        // else {
        //   this.nickname = ''
        //
        //   if (localStorage.getItem('language') === '"th"') {
        //     console.log(localStorage.getItem('language'))
        //     this.$toast({
        //       message: 'ไม่สามารถป้อนอักษรพิเศษได',
        //       position: 'center'
        //     })
        //   } else {
        //     this.$toast({
        //       message: 'special characters are not allowed',
        //       position: 'center'
        //     })
        //   }
        // }
      } else {
        if (this.name === 'Follow') {
          params['filter[userId]'] = this.toUserId;
          params['filter[type]'] = 1;
          params['filter[nickName]'] = '';
          this.getFollowList(params);
        }
        if (this.name === 'Fans') {
          params['filter[userId]'] = this.toUserId;
          params['filter[type]'] = 2;
          params['filter[nickName]'] = '';
          this.getFollowList(params);
        }
      }
    },
    toDetail: function toDetail(threadId, categoryName) {
      this.$router.push({
        path: '/social/detail',
        query: {
          from: categoryName.toLowerCase(),
          threadId: threadId,
          showDetailBack: false
        }
      });
    },
    toTopic: function toTopic(topicId) {
      this.$router.push({
        path: '/social/topic',
        query: {
          topicId: topicId
        }
      });
    },
    getFollowList: function getFollowList(params) {
      var _this2 = this;
      followList(params).then(function (res) {
        if (res.Code === 0) {
          if (res.Data.length === 0) {
            _this2.show = true;
            _this2.followList = res.Data;
          } else {
            _this2.followList = res.Data.pageData;
          }
          console.log(_this2.followList);
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    toCollect: function toCollect(item) {
      var _this3 = this;
      var params = {
        id: item.threadId,
        isFavorite: !item.isFavorite
      };
      collect(params).then(function (res) {
        if (res.Code === 0) {
          if (item.isFavorite) {
            item.likeReward.favoriteCount -= 1;
          } else {
            item.likeReward.favoriteCount += 1;
          }
          item.isFavorite = !item.isFavorite;
        } else {
          _this3.$toast(res.Message);
        }
      });
    },
    thumbsUp: function thumbsUp(item) {
      var _this4 = this;
      var params = {
        data: {
          attributes: {
            isLiked: !item.isLike
          }
        },
        pid: item.postId,
        id: item.threadId
      };
      params.token = JSON.parse(localStorage.getItem('appParams')).token;
      console.log(params);
      thumbs(params).then(function (res) {
        if (res.Code === 0) {
          if (item.isLike) {
            item.likeReward.likePayCount -= 1;
          } else {
            item.likeReward.likePayCount += 1;
          }
          item.isLike = !item.isLike;
        } else {
          _this4.$toast(res.Message);
        }
      });
    },
    getThreadList: function getThreadList(params) {
      var _this5 = this;
      threadList(params).then(function (res) {
        if (res.Code === 0) {
          if (res.Data.pageData.length === 0) {
            _this5.show = true;
          }
          _this5.totalPage = res.Data.totalPage;
          console.log(_this5.clubData, res.Data.pageData, res);
          _this5.clubData = [].concat(_toConsumableArray(_this5.clubData), _toConsumableArray(res.Data.pageData));
          _this5.clubData.forEach(function (item) {
            // 添加视频封面
            if (item.content.indexes['101'] && item.content.indexes['101'].body.length > 0 && item.content.indexes['101'].body[0].type == 2) {
              item.content.indexes['101'].body[0].poster = './defaultPage.png';
            }
            item.content.text = _this5.filter(item.content.text);
          });
          _this5.loading = false;
          _this5.isLoading = false;
        } else {
          // this.$toast(res.Message)
        }
      });
    },
    filter: function filter(html) {
      return html.replace(/<(?:.|\n)*?>/gm, '').replace(/(&rdquo;)/g, '"').replace(/&ldquo;/g, '"').replace(/&mdash;/g, '-').replace(/&nbsp;/g, '').replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/<[\w\s"':=\/]*/, '');
    },
    back: function back() {
      this.$router.back();
    },
    toFollow: function toFollow(userId, item) {
      var _this6 = this;
      var params = {
        toUserId: userId
      };
      follow(params).then(function (res) {
        if (res.Code === 0) {
          var _params2 = {
            page: 1,
            perPage: 10
          };
          if (_this6.name === 'Follow') {
            _params2['filter[userId]'] = _this6.toUserId;
            _params2['filter[type]'] = 1;
            if (_this6.nickname != '') {
              _this6.input(_this6.nickname);
            } else {
              _this6.getFollowList(_params2);
            }
          }
          if (_this6.name === 'Fans') {
            _params2['filter[userId]'] = _this6.toUserId;
            _params2['filter[type]'] = 2;
            if (_this6.nickname != '') {
              _this6.input(_this6.nickname);
            } else {
              _this6.getFollowList(_params2);
            }
          }
        } else {
          _this6.$toast(res.Message);
        }
      });
    },
    toUnfollow: function toUnfollow(userId, item) {
      var _this7 = this;
      var params = {
        type: 1,
        id: userId
      };
      console.log(unFollow, 'params');
      unFollow(params).then(function (res) {
        if (res.Code === 0) {
          var _params3 = {
            page: 1,
            perPage: 10
          };
          if (_this7.name === 'Follow') {
            _params3['filter[userId]'] = _this7.toUserId;
            _params3['filter[type]'] = 1;
            if (_this7.nickname != '') {
              _this7.input(_this7.nickname);
            } else {
              _this7.getFollowList(_params3);
            }
          }
          if (_this7.name === 'Fans') {
            _params3['filter[userId]'] = _this7.toUserId;
            _params3['filter[type]'] = 2;
            if (_this7.nickname != '') {
              _this7.input(_this7.nickname);
            } else {
              _this7.getFollowList(_params3);
            }
          }
        } else {
          _this7.$toast(res.Message);
        }
      });
    }
  }
};